import { RouteRecordRaw } from 'vue-router'

const PARENT_VIEW = () => import('@/layout/routerView.vue')

const routes: RouteRecordRaw[] = [
  {
    path: 'system',
    name: 'system',
    component: PARENT_VIEW,
    redirect: '/system/role',
    meta: { title: '系统管理', icon: 'svg:menu-system', order: 110 },
    children: [
      {
        path: 'role',
        name: 'system_role',
        component: () => import('@/views/System/Role/index.vue'),
        meta: { title: '角色管理', order: 10 }
      },
      {
        path: 'menu',
        name: 'system_menu',
        component: () => import('@/views/System/Menu/index.vue'),
        meta: { title: '菜单管理', order: 20 }
      },
      {
        path: 'role-mobile',
        name: 'system_role_mobile',
        component: () => import('@/views/System/RoleMobile/index.vue'),
        meta: { title: '移动端角色管理', order: 30 }
      },
      {
        path: 'menu-mobile',
        name: 'system_menu_mobile',
        component: () => import('@/views/System/MenuMobile/index.vue'),
        meta: { title: '移动端菜单管理', order: 35 }
      },
    ]
  }
]

export default routes
